import { BrowserRouter as Router, Route } from 'react-router-dom';
import React from 'react';
import GeneralHeader from './components/general-header';
import GeneralFooter from './components/general-footer';
import AppLayout from './AppLayout';
import './App.scss';

const AppRouter = () => (
    <div className="login-app">
        <GeneralHeader />
        <Router>
            <Route render={(props) => <AppLayout {...props} />} />
        </Router>
        <GeneralFooter />
    </div>
);

export default AppRouter;
